export default __webpack_public_path__ + "static/media/64-LotoQuebec.42035cbb.jpg";